define.alias("ember-math-helpers/helpers/sqrt", "media/helpers/sqrt");